<div>
  <mat-form-field appearance="outline" floatLabel="always" class="date-field">
    <input
      matInput
      [errorStateMatcher]="startDatematcher"
      [matDatepicker]="picker1"
      [formControl]="startDateValue"
      (dateChange)="updateStartDate()"
      [attr.aria-label]="startDateLabel"
    />
    <mat-datepicker-toggle
      matSuffix
      [for]="picker1"
      [aria-label]="startCalendarLabel"
    ></mat-datepicker-toggle>
    <mat-datepicker #picker1></mat-datepicker>
    @if (startDateValue.hasError('startDateRequired')) {
      <mat-error> Start Date cannot be empty</mat-error>
    }
    @if (startDateValue.hasError('startDateBeforeEndDate')) {
      <mat-error> Start Date cannot be after End date</mat-error>
    }
  </mat-form-field>
  <span class="span-margin">to</span>
  @if (present) {
    <span class="span-margin present-style" class="present-margin"
      >Present</span
    >
  }
  @if (!present) {
    <mat-form-field appearance="outline" floatLabel="always" class="date-field">
      <input
        matInput
        [errorStateMatcher]="endDatematcher"
        [matDatepicker]="picker2"
        [formControl]="endDateValue"
        (dateChange)="updateEndDate()"
        [attr.aria-label]="endDateLabel"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="picker2"
        [aria-label]="endCalendarLabel"
      ></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
      @if (endDateValue.hasError('endDateRequired')) {
        <mat-error>
          End Date can not be empty. Please check "Present" if there is no End
          date</mat-error
        >
      }
      @if (endDateValue.hasError('startDateBeforeEndDate')) {
        <mat-error> Start Date cannot be after End date</mat-error>
      }
    </mat-form-field>
  }
  <mat-checkbox
    class="checkbox-margin checkbox-text"
    color="primary"
    [formControl]="noEndDate"
    (change)="updatePresent()"
  >
    Present
  </mat-checkbox>
</div>
